import $ from "jquery"
import "jquery-autocomplete"
import "jquery-autocomplete/jquery.auto-complete.css"

import React from 'react'
import ReactDOM from "react-dom";

import "../scss/index.scss"

import StartseiteAuszug from './components/StartseiteAuszug'


$(()=>{

    $(".startseite-auszug").each((i, elem) => {

        const $elem = $(elem);
        const root = $elem.find(".startseite-auszug-root")[0];

        ReactDOM.render(
            <StartseiteAuszug
                zitate_url={$elem.data("zitate-url")}
                mode={$elem.data("mode")}
                pks={$elem.data("pks")}
            />,
            root
        );

    });

});


// WEBPACK FOOTER //
// ./cms_plugins/startseite_auszug/js/index.js